import React, {useEffect} from 'react';
import {connect} from "react-redux";
import {dashboardActions} from "../../../modules/dashboard/dashboard.actions.js";
import {helper} from "../../../utils/helper.js";
import Grid from "@mui/material/Grid2";
import {Stack} from "@mui/material";
import Loader from "../layout/loading/loader.js";
import './DashboardViewV2.css'
import DashboardModalDetailsWorkDone from "./modals/DashboardModalDetailsWorkDone.js";
import DashboardHeaderControls from "./ui/DashboardHeaderControls.js";
import {dashboardHelper} from "./utils/dashboardHelper.js";
import TourneeAccordion from "./ui/TourneeAccordion.js";
import Constants from "../../../utils/constants.js";

const MODAL_VIEW = {
    MODAL_VIEW_FULL: 1,
    MODAL_VIEW_IMPOSSIBLE: 2
}

function DashboardClientView({data, loading, error, dispatch, onModeChange, ...props}) {
    const [selectedDate, setSelectedDate] = React.useState(dashboardHelper.formatDateRelative(0))
    const [selectedTournee, setSelectedTournee] = React.useState(null);
    const [modalOpen, setModalOpen] = React.useState(false);
    const [modalView, setModalView] = React.useState(MODAL_VIEW.MODAL_VIEW_FULL);
    let currentUser = helper.getCurrentUser();

    const loadData = (forceReload = false) => {
        if (!loading && (!error || forceReload)) {
            let values = {clientId: currentUser?.id, date: selectedDate};
            dispatch(dashboardActions.fetchDashboardDataClient(values));
        }
    };

    useEffect(() => {
        if (!data) {
            loadData();
        }
        const intervalId = setInterval(loadData, 900000); // 900000 ms = 15 minutes

        // Nettoyage de l'effet
        return () => clearInterval(intervalId);
    }, [currentUser, dispatch]);

    const handleOpenModal = (tourneeId, date, onlyImpossible = false) => {
        if (onlyImpossible) {
            setModalView(MODAL_VIEW.MODAL_VIEW_IMPOSSIBLE)
        } else {
            setModalView(MODAL_VIEW.MODAL_VIEW_FULL)
        }
        setSelectedTournee({tourneeId, date});
        setModalOpen(true);
    };

    return (
        <Grid container>
            <DashboardHeaderControls
                selectedDate={selectedDate}
                onDateChange={(date) => {
                    setSelectedDate(date);
                    let values = {clientId: currentUser?.id, date: date};
                    dispatch(dashboardActions.fetchDashboardDataClient(values));
                }}
                onReload={() => loadData(true)}
                lastUpdated={data?.lastUpdated}
                viewMode={Constants.DASHBOARD_VIEW_MODE_LIST}
            />


            {loading &&
                <Grid item size={12}>
                    <Loader/>
                </Grid>
            }

            {!loading &&
                <>
                    <Stack sx={{width: "100%", marginTop: "2rem"}}>
                        {data && data.tournees && data.tournees.map((tournee, idx) => (
                            <TourneeAccordion
                                key={idx}
                                data={tournee}
                                selectedDate={selectedDate}
                                onTourneeClick={() => handleOpenModal(tournee.id, selectedDate)}
                                onTourneeImpossibleClick={() => handleOpenModal(tournee.id, selectedDate, true)}
                            />
                        ))}
                    </Stack>

                    {modalOpen && selectedTournee && (
                        <DashboardModalDetailsWorkDone
                            open={modalOpen}
                            onClose={() => setModalOpen(false)}
                            tourneeId={selectedTournee.tourneeId}
                            date={selectedTournee.date}
                            onlyShowImpossible={modalView === MODAL_VIEW.MODAL_VIEW_IMPOSSIBLE}
                        />
                    )}
                </>
            }
        </Grid>
    )
}

const mapStateToProps = function (state) {
    return {
        data: state.dashboard.dataClient,
        loading: state.dashboard.loading,
        error: state.dashboard.error
    }
}

export default connect(mapStateToProps)(DashboardClientView);
